import { TCollectionInfo, TCollectionsFilters } from "../bloc/collectionsSlice";


export const getUpdatedCollections = (searchText: string, collections: TCollectionInfo[], filters: TCollectionsFilters) => {
    let updatedCollections = collections;
    if (searchText.length > 0) {
        updatedCollections = updatedCollections.filter((collection) =>
            collection.utr.toLowerCase().includes(searchText.toLocaleLowerCase()) ||
            collection.customer.toLowerCase().includes(searchText.toLocaleLowerCase())
        )
    }
    if (filters.selectedModes.length > 0) {
        updatedCollections = updatedCollections.filter((payout) => filters.selectedModes.includes(payout.paymentSource));
    }
    if (filters.selectedStatuses.length > 0) {
        updatedCollections = updatedCollections.filter((payout) =>
            filters.selectedStatuses.map((s) => s.toLocaleLowerCase()).includes(payout.status.toLocaleLowerCase()));
    }
    if (filters.selectedCustomers.length > 0) {
        updatedCollections = updatedCollections.filter((payout) => filters.selectedCustomers.includes(payout.customer));
    }
    return updatedCollections;
}